var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex items-center flex-grow-0 w-full border-b border-slate-400",
      class: {
        "bg-pure-white": !_vm.isAdded,
        "bg-slate-200": _vm.isAdded
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex justify-between flex-shrink-0 gap-2 px-4 py-3 overflow-hidden border-r h-22 border-slate-400",
          style: { width: "20%" },
          attrs: { title: _vm.target.name }
        },
        [
          _c(
            "div",
            { staticClass: "flex gap-2" },
            [
              _vm.useCheckbox
                ? _c("BlInputCheck", {
                    staticClass: "mt-1",
                    attrs: { checked: _vm.isChecked, disabled: _vm.isAdded },
                    on: {
                      changed: function($event) {
                        return _vm.$emit("check")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("select")
                    }
                  }
                },
                [
                  _c("BlTextBody1", {
                    staticClass:
                      "cursor-pointer text-slate-1000 line-clamp-2 h-13 hover:underline",
                    style: {
                      textDecoration: "underline",
                      textDecorationColor: "#D0D5DD"
                    },
                    attrs: { text: _vm.target.name }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.useAddButton
            ? _c("BlInputButton", {
                attrs: {
                  type: "outlined",
                  dense: "",
                  disabled: _vm.isAdded,
                  label: _vm.isAdded ? "Added" : "Add"
                },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("add")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.useCurriculum
        ? _c(
            "div",
            {
              staticClass: "flex flex-shrink-0 gap-2 px-4 py-3 h-22",
              style: { width: "15%" },
              attrs: { title: _vm.target.curriculum_name }
            },
            [
              _c("div", {
                staticClass: "h-4 w-4 flex-shrink-0 rounded-full mt-0.5",
                style: { backgroundColor: _vm.target.curriculum_color }
              }),
              _vm._v(" "),
              _c("BlTextBody1", {
                staticClass: "line-clamp-2 h-13",
                attrs: { text: _vm.target.curriculum_name }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 px-4 py-3 h-22",
          style: { width: _vm.descriptionWidth },
          attrs: { title: _vm.target.description }
        },
        [
          _c("BlTextBody1", {
            staticClass: "whitespace-pre-line line-clamp-2 h-13",
            attrs: { text: _vm.target.description }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 px-4 py-3 h-22",
          style: { width: "15%" }
        },
        [
          _c("BlTextBody1", {
            attrs: { text: _vm.targetTypes[_vm.target.type] }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 px-4 py-3 space-y-2 h-22",
          style: { width: _vm.successMetricWidth }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex items-start gap-2",
              attrs: { title: _vm.generateSuccessMetric(_vm.target) }
            },
            [
              _c("BlIcon", {
                staticClass: "w-5 mt-0.5",
                attrs: { icon: "goal", color: "slate-6" }
              }),
              _vm._v(" "),
              _c("BlTextBody1", {
                staticClass: "line-clamp-2",
                attrs: { text: _vm.generateSuccessMetric(_vm.target) }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.target.type.includes("Percentage")
            ? _c(
                "div",
                { staticClass: "flex gap-2" },
                [
                  _c("BlIcon", {
                    staticClass: "w-5",
                    attrs: { icon: "tick-square", color: "slate-6" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody1", {
                    attrs: { text: _vm.target.number_of_trial + " trial(s)" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.target.type.includes("Pir")
            ? _c(
                "div",
                { staticClass: "flex gap-2" },
                [
                  _c("BlIcon", {
                    staticClass: "w-5",
                    attrs: { icon: "timer", color: "slate-6" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody1", {
                    attrs: { text: _vm.target.duration + " minute(s)" }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.useAction
        ? _c(
            "div",
            {
              staticClass:
                "flex justify-end flex-shrink-0 gap-2 px-4 py-3 h-22",
              style: { width: "10%" }
            },
            [
              _c("BlInputButton", {
                attrs: { label: "Duplicate", type: "outlined", dense: "" },
                on: {
                  clicked: function($event) {
                    _vm.duplicateOpened = true
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { label: "Edit", type: "outlined", dense: "" },
                on: {
                  clicked: function($event) {
                    _vm.editOpened = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.duplicateOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Duplicate the target",
                label: "Duplicate the target",
                type: "success",
                disabled: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.duplicateOpened = false
                },
                "backdrop-action": _vm.onDuplicate
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-8", style: { width: "70ch" } },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "You are about to duplicate the target" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: "" + _vm.target.name }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", { attrs: { text: "to the databank." } }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "Are you sure you want to proceed?" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editOpened
        ? _c("SuperAdminDatabankEditModal", {
            attrs: {
              targetId: _vm.target.id,
              disabledUpdateCurriculum: _vm.disabledUpdateCurriculum
            },
            on: {
              "close-modal": function($event) {
                _vm.editOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-758e0c11", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758e0c11","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/databank/Item.vue
// module id = null
// module chunks = 